import { Route, useRouteMatch, useHistory } from "react-router-dom";
import { imgUrl } from "./modules/Arrays";
import Song from "./Song";
import Track from "./Track";

function Singles({ singles }) {
    const history = useHistory();
    const { url, path } = useRouteMatch();
    const singless = singles.map(single => (
        <Track 
            song={single} 
            key={single.id} 
            link={`${url}/${single.title.replace(/ /g,'-')}`} 
            img={imgUrl+"next.png"} 
            alt={`Go to ${ single.title }`} />
    ));

    return (
      <>
        <Route exact path={path}>
            <div className="musicals singles">
                <button onClick={history.goBack}>Back</button>
                <h4>All Singles</h4>
                <div className="grid-4">
                    { singless }
                </div>
            </div>
        </Route>

        <Route path={path+"/:track"}>
            <Song tracks={singles}/>
        </Route>
      </>
    );
  }
  
  export default Singles;